export const documentLibrarySystemPermissions = {
    /**
     * document library management
     */
    'manage-documents': {
        group: 'Document Library',
        label: 'Manage Documents',
    },
};
